module.exports = __webpack_public_path__ + "static/media/strefa-cv.581fbde0.svg";